import styled from 'styled-components';

const Container = styled.div`
  ${({ theme }) => `
    position: relative;
    overflow-x: hidden;
    background-color: ${theme.colors.white};

    > *:first-child:not(header):not(nav) {
      margin-top: 5rem;
    }
  `}
`;

const Content = styled.div`
  ${({ theme }) => `
    background-color: ${theme.colors.white};
    color: ${theme.colors.dark};
  `}
`;

export { Container, Content };
